import {Button, styled} from "@mui/material";

// Add button
export const LinkButton = styled(Button)(({theme}) => ({
    minWidth: 'unset',
    width: 'max-content',
    height: 'max-content',
    color: theme.barekam.green,
    padding: '0.5rem',
    gap: '0.25rem'
}));

export const TextButton = styled(Button)(({theme}) => ({
    minWidth: '2.5rem',
    color: theme.barekam.green,
    fontWeight: 700,
    padding: '0'
}));

export const TermsAndConditionsButton = styled(LinkButton)(() => ({
    color: '#fff',
    padding: '0',
    textDecoration: 'underline'
}));
